export default __webpack_public_path__ + "static/media/noteIcon.1731047f.svg";